import BreadcrumbNav from './BreadcrumbNav';

export default BreadcrumbNav;



// WEBPACK FOOTER //
// ./src/views/components/BreadcrumbNavigation/index.js